import { useState } from "react";
import { Link } from "react-router-dom";
import { useRegister } from "../../context/RegisterContext";
import { useAuth } from "../../context/AuthNewContext";
import { usePassAuth } from "../../context/PasswordAuthContext";
import { useNavigate } from "react-router-dom";
import qkLogo from "../../assets/qk_logo.png";
import "./LoginForm.css";

// const LoginForm = () => {
//   const { loginUser, loading, error } = useLogin();

//   const [form, setForm] = useState({
//     username: "",
//     password: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [showModal, setShowModal] = useState(false);
//   const [modalMessage, setModalMessage] = useState("");
//   const [modalType, setModalType] = useState("success");

//   /* ================= VALIDATION ================= */
//   const validate = () => {
//     const newErrors = {};

//     if (!form.username.trim()) {
//       newErrors.username = "Username or Email required";
//     }

//     if (!form.password) {
//       newErrors.password = "Password required";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   /* ================= HANDLERS ================= */
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm({ ...form, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     try {
//       await loginUser(form);

//       setModalType("success");
//       setModalMessage("Login successful");
//       setShowModal(true);
//     } catch (err) {
//       const backendMessage =
//         err?.response?.data?.message ||
//         error ||
//         "Login failed. Please try again.";

//       setModalType("error");
//       setModalMessage(backendMessage);
//       setShowModal(true);
//     }
//   };

//   return (
//     <div className="reg-page-wrapper">
//       <h2 className="reg-page-title">Login</h2>

//       <form className="reg-form" onSubmit={handleSubmit}>
//         {/* ================= USERNAME ================= */}
//         <input
//           className="reg-input"
//           name="username"
//           placeholder="Username / Email"
//           onChange={handleChange}
//         />
//         {errors.username && <p className="reg-error">{errors.username}</p>}

//         {/* ================= PASSWORD ================= */}
//         <input
//           className="reg-input"
//           type="password"
//           name="password"
//           placeholder="Password"
//           onChange={handleChange}
//         />
//         {errors.password && <p className="reg-error">{errors.password}</p>}

//         <button className="reg-submit-btn" disabled={loading}>
//           {loading ? "Logging in..." : "Login"}
//         </button>
//       </form>

//       {/* ================= REGISTER LINK ================= */}
//       <p style={{ textAlign: "center", marginTop: "16px" }}>
//         Don’t have an account?{" "}
//         <Link to="/register" style={{ fontWeight: "500" }}>
//           Register
//         </Link>
//       </p>

//       {/* ================= MODAL ================= */}
//       {showModal && (
//         <div className="reg-modal-overlay">
//           <div className="reg-modal">
//             <h3
//               className={
//                 modalType === "success"
//                   ? "reg-modal-success"
//                   : "reg-modal-error"
//               }
//             >
//               {modalType === "success" ? "Success" : "Error"}
//             </h3>
//             <p>{modalMessage}</p>
//             <button
//               className="reg-modal-btn"
//               onClick={() => setShowModal(false)}
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// const LoginForm = () => {
//   const { loginUser, loading, error, userNotFound } = useRegister();
//   const { login, logout } = useAuth();
//   const { checkResetStatus } = usePassAuth();
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     username: "",
//     password: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [showModal, setShowModal] = useState(false);
//   const [apiError, setApiError] = useState("");
//   const [modalMessage, setModalMessage] = useState("");
//   const [modalType, setModalType] = useState("success");

//   /* ================= VALIDATION ================= */
//   const validate = () => {
//     const newErrors = {};

//     if (!form.username.trim()) {
//       newErrors.username = "Username or Email required";
//     }

//     if (!form.password) {
//       newErrors.password = "Password required";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   /* ================= HANDLERS ================= */
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm({ ...form, [name]: value });
//   };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   if (!validate()) return;

//   //   try {
//   //     await loginUser(form);

//   //     setModalType("success");
//   //     setModalMessage("Login successful");
//   //     setShowModal(true);
//   //   } catch (err) {
//   //     const code = err?.response?.data?.code;
//   //     const message =
//   //       err?.response?.data?.message ||
//   //       error ||
//   //       "Login failed. Please try again.";

//   //     if (code === "USER_NOT_FOUND") {
//   //       setModalType("error");
//   //       setModalMessage("User not found. Please register first.");
//   //       setShowModal(true);
//   //       return;
//   //     }

//   //     setModalType("error");
//   //     setModalMessage(message);
//   //     setShowModal(true);
//   //   }
//   // };
//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   if (!validate()) return;

//   //   try {
//   //     // await loginUser(form);
//   //     const res = await loginUser(form);

//   //     // 🔥 STORE USERID IN CONTEXT (NO localStorage)
//   //     login({ userID: res.userID });
//   //     setModalType("success");
//   //     setModalMessage("Login successful");
//   //     setShowModal(true);
//   //   } catch (err) {
//   //     const code = err?.response?.data?.code;
//   //     const message =
//   //       err?.response?.data?.message || "Login failed. Please try again.";

//   //     if (code === "USER_NOT_FOUND") {
//   //       setModalType("error");
//   //       setModalMessage("User not found. Please register first.");
//   //       setShowModal(true);
//   //       return;
//   //     }

//   //     if (code === "EMAIL_NOT_VERIFIED") {
//   //       setModalType("error");
//   //       setModalMessage("Please verify your email first. Check your inbox.");
//   //       setShowModal(true);
//   //       return;
//   //     }

//   //     setModalType("error");
//   //     setModalMessage(message);
//   //     setShowModal(true);
//   //   }
//   // };
//   const handleForgot = async () => {
//     if (!form.username.trim()) {
//       setErrors({ username: "Please enter your email first" });
//       return;
//     }

//     try {
//       const res = await checkResetStatus(form.username);
//       console.log(res);
//       if (res.verified) {
//         // account already unlocked → direct reset
//         navigate(`/reset-password?email=${form.username}&account=direct`);
//       }
//       if (!res.userExists) {
//         setModalType("error");
//         setModalMessage("User not found. Please register first.");
//         setShowModal(true);
//         return;
//       } else {
//         // account locked → go to forgot password page
//         navigate(`/forgot-password?email=${form.username}`);
//       }
//     } catch (err) {
//       console.log("status check error:", err);

//       // fallback
//       navigate(`/forgot-password?email=${form.username}`);
//     }
//   };
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     try {
//       const res = await loginUser(form);

//       login({
//         userID: res.userID,
//         token: res.token,
//         loginId: res.loginHistoryId,
//         role: res.role,
//       });
//       navigate("/dashboard");

//       // setModalType("success");
//       // setModalMessage("Login successful");
//       // setShowModal(true);
//     } catch (err) {
//       //  catch (err) {
//       //   const code = err?.response?.data?.code;
//       //   const message =
//       //     err?.response?.data?.message || "Login failed. Please try again.";

//       //   if (code === "USER_NOT_FOUND") {
//       //     setModalType("error");
//       //     setModalMessage("User not found. Please register first.");
//       //     setShowModal(true);
//       //     return;
//       //   }

//       //   if (code === "EMAIL_NOT_VERIFIED") {
//       //     setModalType("error");
//       //     setModalMessage("Please verify your email first. Check your inbox.");
//       //     setShowModal(true);
//       //     return;
//       //   }

//       //   if (code === "ACCOUNT_LOCKED") {
//       //     setModalType("error");
//       //     setModalMessage(
//       //       "Your account is locked due to multiple failed login attempts. Redirecting to reset password...",
//       //     );
//       //     setShowModal(true);

//       //     setTimeout(() => {
//       //       navigate("/forgot-password");
//       //     }, 2000);

//       //     return;
//       //   }

//       //   /* EXISTING FALLBACK */
//       //   setModalType("error");
//       //   setModalMessage(message);
//       //   setShowModal(true);
//       // }
//       const code = err?.response?.data?.code;
//       const message =
//         err?.response?.data?.message || "Login failed. Please try again.";

//       if (code === "USER_NOT_FOUND") {
//         setApiError("User not found. Please register first.");
//         return;
//       }

//       if (code === "EMAIL_NOT_VERIFIED") {
//         setApiError("Please verify your email first. Check your inbox.");
//         return;
//       }

//       if (code === "ACCOUNT_LOCKED") {
//         setApiError(
//           "Account locked due to multiple failed attempts. Redirecting...",
//         );

//         setTimeout(() => {
//           navigate("/forgot-password");
//         }, 2000);

//         return;
//       }

//       setApiError(message);
//     }
//   };
//   return (
//     <div className="reg-par-container">
//       {" "}
//       <div className="reg-page-wrapper log-page-wrapper">
//         <h2 className="reg-page-title">Login</h2>

//         <form className="reg-form" onSubmit={handleSubmit}>
//           {/* ================= USERNAME ================= */}
//           <input
//             className="reg-input"
//             name="username"
//             placeholder="Username / Email"
//             value={form.username}
//             onChange={handleChange}
//           />
//           {errors.username && <p className="reg-error">{errors.username}</p>}

//           {/* ================= PASSWORD ================= */}
//           <input
//             className="reg-input"
//             type="password"
//             name="password"
//             placeholder="Password"
//             value={form.password}
//             onChange={handleChange}
//           />
//           {errors.password && <p className="reg-error">{errors.password}</p>}
//           <p
//             style={{
//               textAlign: "right",
//               marginTop: "6px",
//               fontSize: "14px",
//               cursor: "pointer",
//               color: "#007bff",
//             }}
//             onClick={handleForgot}
//           >
//             Forgot Password?
//           </p>

//           <button className="reg-submit-btn" disabled={loading}>
//             {loading ? "Logging in..." : "Login"}
//           </button>
//           {apiError && <p className="reg-error">{apiError}</p>}
//         </form>

//         {/* ================= REGISTER LINK ================= */}
//         <p style={{ textAlign: "center", marginTop: "16px" }}>
//           Don’t have an account?{" "}
//           <Link to="/register" style={{ fontWeight: "500" }}>
//             Register
//           </Link>
//         </p>

//         {/* {showModal && (
//         <div className="reg-modal-overlay">
//           <div className="reg-modal">
//             <h3
//               className={
//                 modalType === "success"
//                   ? "reg-modal-success"
//                   : "reg-modal-error"
//               }
//             >
//               {modalType === "success" ? "Success" : "Error"}
//             </h3>

//             <p>{modalMessage}</p>

//             <div className="reg-modal-actions">
//               {modalType === "error" && userNotFound ? (
//                 <>
//                   <button
//                     className="reg-modal-btn"
//                     onClick={() => navigate("/register")}
//                   >
//                     Register
//                   </button>

//                   <button
//                     className="reg-modal-btn secondary"
//                     onClick={() => setShowModal(false)}
//                   >
//                     Cancel
//                   </button>
//                 </>
//               ) : (
//                 <button
//                   className="reg-modal-btn"
//                   onClick={() => {
//                     setShowModal(false);
//                   }}
//                 >
//                   OK
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )} */}
//       </div>
//     </div>
//   );
// };

const LoginForm = () => {
  const { loginUser, loading, error, userNotFound } = useRegister();
  const { login, logout } = useAuth();
  const { checkResetStatus } = usePassAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [apiError, setApiError] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success");

  /* ================= VALIDATION ================= */
  const validate = () => {
    const newErrors = {};

    if (!form.username.trim()) {
      newErrors.username = "Username or Email required";
    }

    if (!form.password) {
      newErrors.password = "Password required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ================= HANDLERS ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleForgot = async () => {
    if (!form.username.trim()) {
      setErrors({ username: "Please enter your email first" });
      return;
    }

    try {
      const res = await checkResetStatus(form.username);
      console.log(res);
      if (res.verified) {
        navigate(`/reset-password?email=${form.username}&account=direct`);
      }
      if (!res.userExists) {
        setModalType("error");
        setModalMessage("User not found. Please register first.");
        setShowModal(true);
        return;
      } else {
        navigate(`/forgot-password?email=${form.username}`);
      }
    } catch (err) {
      console.log("status check error:", err);
      navigate(`/forgot-password?email=${form.username}`);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const res = await loginUser(form);

      login({
        userID: res.userID,
        token: res.token,
        loginId: res.loginHistoryId,
        role: res.role,
      });
      navigate("/dashboard");
    } catch (err) {
      const code = err?.response?.data?.code;
      const message =
        err?.response?.data?.message || "Login failed. Please try again.";

      if (code === "USER_NOT_FOUND") {
        setApiError("User not found. Please register first.");
        return;
      }

      if (code === "EMAIL_NOT_VERIFIED") {
        setApiError("Please verify your email first. Check your inbox.");
        return;
      }

      if (code === "ACCOUNT_LOCKED") {
        setApiError(
          "Account locked due to multiple failed attempts. Redirecting...",
        );

        setTimeout(() => {
          navigate("/forgot-password");
        }, 2000);

        return;
      }

      setApiError(message);
    }
  };

  return (
    <div className="login-page">
      {/* ── LEFT PANEL: BRANDING ── */}
      <div className="login-left">
        <div className="login-left-content">
          <div
            className="login-logo"
            onClick={() => navigate("/")}
            role="button"
            tabIndex={0}
          >
            <span className="login-logo-mark">
              {" "}
              <img src={qkLogo} alt="" className="login-logo-img" />
            </span>
            <span className="login-logo-text">QuantKubera</span>
          </div>

          <div className="login-left-hero">
            <h1>Welcome back.</h1>
            <p>
              Track option chains, max pain, PCR and trends — all in one
              dashboard.
            </p>
          </div>

          {/* Decorative mini dashboard */}
          <div className="login-mini-dash">
            <div className="lmd-row">
              <div className="lmd-kpi">
                <span className="lmd-label">PCR</span>
                <span className="lmd-val lp-green">0.82</span>
              </div>
              <div className="lmd-kpi">
                <span className="lmd-label">Max Pain</span>
                <span className="lmd-val">22,400</span>
              </div>
              <div className="lmd-kpi">
                <span className="lmd-label">IV Rank</span>
                <span className="lmd-val lp-red">67.2</span>
              </div>
            </div>
            <div className="lmd-bars">
              {[40, 65, 35, 80, 50, 72, 45, 90, 55, 38, 70, 60].map((h, i) => (
                <div
                  key={i}
                  className={`lmd-bar${i === 7 ? " active" : ""}`}
                  style={{ height: `${h}%` }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── RIGHT PANEL: FORM ── */}
      <div className="login-right">
        {/* Mobile logo */}
        <div
          className="login-mobile-logo"
          onClick={() => navigate("/")}
          role="button"
          tabIndex={0}
        >
          <span className="login-logo-mark">
            {" "}
            <img src={qkLogo} alt="" className="login-logo-img" />
          </span>
          <span className="login-logo-text">QuantKubera</span>
        </div>

        <div className="login-form-wrap">
          <h2>Login</h2>
          <p className="login-form-sub">
            Enter your credentials to access your dashboard.
          </p>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-field">
              <label htmlFor="username">Username or Email</label>
              <input
                id="username"
                name="username"
                type="text"
                placeholder="you@example.com"
                value={form.username}
                onChange={handleChange}
                autoComplete="username"
              />
              {errors.username && (
                <p className="login-error">{errors.username}</p>
              )}
            </div>

            <div className="login-field">
              <div className="login-field-header">
                <label htmlFor="password">Password</label>
                <span className="login-forgot" onClick={handleForgot}>
                  Forgot password?
                </span>
              </div>
              <input
                id="password"
                name="password"
                type="password"
                placeholder="••••••••"
                value={form.password}
                onChange={handleChange}
                autoComplete="current-password"
              />
              {errors.password && (
                <p className="login-error">{errors.password}</p>
              )}
            </div>

            {apiError && <p className="login-api-error">{apiError}</p>}

            <button type="submit" className="login-submit" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>

          <p className="login-register">
            Don't have an account?{" "}
            <Link to="/register" className="login-link">
              Register
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
